

import './Tab&Desktop.css'
import { Routes, Route } from "react-router-dom";
import Home from './Home';
import TableExample from './hiatory';
import Login from './login';
import RegisterUser from './Admin/RegisterUser';
import FormComponent from '../../components/FormComponent';
import SuperAdminIndex from './SuperAdmin';
import SuperHomeDesktop from './SuperAdmin/Company';
import MemeberHome from './SuperAdmin/Member';
import FormHome from './SuperAdmin/Form';
import SideBar from './SuperAdmin/Componet/Sidebar';
import FormType2 from '../../components/formtype2';
import FormView from './SuperAdmin/Componet/formview';
const TabHomePage = () => {
 
  return ( 
    
       <Routes>
           <Route exact path = '/' element ={<Home />}/>
           <Route path="/login" element ={<Login/>}/>
           <Route path="/survey1"  element ={<FormComponent/>}/>
           <Route path='/survey2' element= {<FormType2/>}/>
           <Route path="/adminPage"  element ={<RegisterUser/>}/>
           <Route path="/history" element={<TableExample/>} />
           <Route path="/member" element={<MemeberHome/>} />
           <Route path='/company' element={<SuperHomeDesktop/>} />
           <Route path='/form' element={<FormHome/>}/>
           <Route path='/sidebar' element = {<SideBar/>} />
           <Route path='/formview/:cfd' element={<FormView/>} />

       </Routes>
    
    
  );
}
 
export default TabHomePage;